import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/state/appState';
import { AppDispatch } from '../../store/actions/appDispatch';
import {
	nextCreateJobStep,
	updateCreateJobCustomField,
	updateCreateJobName
} from '../../store/actions/createJobActions';
import './CreateJobGatherInfoStep.scss';
import { isCurrentCreateJobStepValid } from '../../store/selectors/createJobSelectors';
import { GatherInfoStep } from '../../store/state/createJobState';
import { Link } from 'react-router-dom';

export default function CreateJobGatherInfoStep(props: Props) {
	const isStepValid = useSelector<AppState, boolean>(s => isCurrentCreateJobStepValid(s, props.engagementId));
	const dispatch = useDispatch<AppDispatch>();
	
	return (
		<React.Fragment>
			<div className="page-container page-container_more-space-on-top">
				<h1 className="h1-mb-1 text-center">Let’s get started</h1>

				<div className="header-description-container header-description-container_wide">
					The following details will be used to structure your data. 
					We recommend using common langauge that your organization is familiar with.
				</div>

				<div className="create-job-gather-info-step__fields-section">
				
					{/*NAME*/}
					<div className="create-job-gather-info-step__field-label">Enter job name (eg: Service team)</div>
					<div className="create-job-gather-info-step__field-input-container">
						<input type="text"
							   className="text-input"
							   value={props.step.name}
							   onChange={e => dispatch(updateCreateJobName(props.engagementId, e.target.value))} />
					</div>

					{/*FIELDS*/}
					{props.step.customFields.map(f => (
						<React.Fragment key={f.fieldId}>
							<div className="create-job-gather-info-step__field-label">{f.fieldDisplayName} {!f.required && <span>(optional)</span>}</div>
							<div className="create-job-gather-info-step__field-input-container">
								<input type="text"
									   className="text-input"
									   value={f.value}
									   onChange={e => dispatch(updateCreateJobCustomField(props.engagementId, f.fieldId, e.target.value))} />
									   
								{fieldValueIsTooLong(f.value) &&
								<div className="mt-2 text-red">Value is too long</div>
								}
								
								{(!!f.defaultValue && f.value !== f.defaultValue) &&
								<div className="create-job-gather-info-step__field-reset">
									<button className="btn btn_link" onClick={() => dispatch(updateCreateJobCustomField(props.engagementId, f.fieldId, f.defaultValue ?? ''))}>Reset</button>
								</div>
								}
							</div>
							
						</React.Fragment>
					))}

					<div className="mt-4"><button className="btn btn_full" onClick={() => dispatch(nextCreateJobStep(props.engagementId))} disabled={!isStepValid || isAnyFieldValueTooLong()}>Continue</button></div>
					<div className="mt-3 text-center"><Link to={`/engagements/${props.engagementId}`}>Close</Link></div>
				</div>
			</div>
		</React.Fragment>
	);
	
	function fieldValueIsTooLong(val: string): boolean {
		return (val ?? '').length > 500;	
	}
	
	function isAnyFieldValueTooLong(): boolean {
		return props.step.customFields.some(f => fieldValueIsTooLong(f.value));
	}
}

interface Props {
    step: GatherInfoStep;
    engagementId: number;
}
